import {useIntl} from 'react-intl'
import {CrudProvider} from '../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../parts/crud/Charts'

import 'bootstrap-daterangepicker/daterangepicker.css'
import moment from 'moment'

import {useState} from 'react'

import {getBaseBarChartOptions} from '../../parts/crud/Types'
import {DataRangeFilter} from '../../parts/filters/DataRangeFilter'
import {ServerFilter} from '../../parts/filters/ServerFilter'

export const UserManagedEvents = () => {
  const intl = useIntl()
  const [server, setServer] = useState('all')

  const [group_selected, setGroupSelected] = useState<any>(null)
  const [servers, setServers] = useState([])
  const [servers_selected, setServersSelected] = useState<any>([])
  const [error, setError] = useState('')
  const [filterData, setFilterData] = useState<any>(null)
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(6, 'days'),
    end: moment(),
  })

  const submitData = async () => {
    if (
      server === 'oneormore' &&
      (servers_selected === null ||
        (Array.isArray(servers_selected) && servers_selected.length === 0))
    ) {
      setError(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_SERVER'}))
      return
    }
    setError('')
    let data: any = {
      date_range: {
        start: dateRange.start.format('YYYY-MM-DD') + ' 00:00:00',
        end: dateRange.end.format('YYYY-MM-DD') + ' 23:59:59',
      },
      server: server,
      group_list: group_selected ? group_selected.value : null,
      selected_server: servers_selected.map((srv: any) => srv.value),
      tz: new Date().getTimezoneOffset(),
    }

    setFilterData(data)
  }
  let params: any = {
    intl,
    title: intl.formatMessage({id: 'MENU.OPERATION_RANKING.USER_MANAGED_EVENTS'}),
    yAxisTitle: intl.formatMessage({id: 'OPERATION_RANKING.USER_MANAGED_EVENTS.Y_AXIS'}),
    pointFormat:
      '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}' +
      intl.formatMessage({id: 'OPERATION_RANKING.USER_MANAGED_EVENTS.EVENTS'}) +
      '</b><br/>',
  }
  let baseChartOptions = {...getBaseBarChartOptions(params)}
  return (
    <>
      <CrudProvider api='operation-ranking/user-managed-events'>
        <ChartsComponent filterData={filterData} baseChartOptions={baseChartOptions}>
          <p>{intl.formatMessage({id: 'OPERATION_RANKING.USER_MANAGED_EVENTS.TEXT'})}</p>
          <DataRangeFilter
            onChangedDataRange={(start, end) => {
              setDateRange({
                start: start,
                end: end,
              })
            }}
          />
          <ServerFilter
            onChangedServer={(server) => {
              setServer(server)
            }}
            onChangedServersSelected={(servers) => {
              setServersSelected(servers)
            }}
            
          />

          {error && <div className='alert alert-danger'>{error}</div>}
          <input
            type='button'
            className='btn btn-primary'
            onClick={submitData}
            value={intl.formatMessage({id: 'GENERIC.SUBMIT'})}
          />
        </ChartsComponent>
      </CrudProvider>
    </>
  )
}
